import { ComponentStatusMap } from '../../../../../constants/chips/component-status.constants';
import { EvidenceStatusMap } from '../../../../../constants/chips/evidence-status.constants';

export const calculateComponentStatus = (subcomponents) => {
    const validStatuses = subcomponents.map((sc) => sc.statusId).filter(Number.isFinite);

    if (validStatuses.length === 0) {
        return ComponentStatusMap.default;
    }

    const statusCounts = countStatusTypes(validStatuses);
    const totalCount = validStatuses.length;

    // Priority order: rejected > problems > complete > inReview > inProgress > todo
    if (isAllRejected(statusCounts, totalCount)) {
        return ComponentStatusMap.rejected;
    }

    if (hasProblems(statusCounts)) {
        return ComponentStatusMap.problems;
    }

    if (isAllComplete(statusCounts, totalCount)) {
        return ComponentStatusMap.complete;
    }

    if (hasInReviewItems(statusCounts) || isAllInProgress(statusCounts, totalCount)) {
        return ComponentStatusMap.inReview;
    }

    if (hasProgressItems(statusCounts)) {
        return ComponentStatusMap.inProgress;
    }

    return ComponentStatusMap.todo;
};

const countStatusTypes = (statuses) => {
    const statusMapping = {
        [EvidenceStatusMap.default]: 'notStarted',
        [EvidenceStatusMap.notStarted]: 'notStarted',
        [EvidenceStatusMap.submitted]: 'submitted',
        [EvidenceStatusMap.approved]: 'approved',
        [EvidenceStatusMap.rejected]: 'rejected',
    };

    return statuses.reduce(
        (counts, status) => {
            const countKey = statusMapping[status];
            if (countKey) {
                counts[countKey]++;
            }
            return counts;
        },
        {
            notStarted: 0,
            submitted: 0,
            approved: 0,
            rejected: 0,
        }
    );
};

const isAllRejected = (counts, total) => {
    return counts.rejected === total;
};

const hasProblems = (counts) => {
    const hasRejectedItems = counts.rejected > 0;
    return hasRejectedItems;
};

const isAllComplete = (counts, total) => {
    return counts.approved === total;
};

const hasInReviewItems = (counts) => {
    const hasIncompleteItems = counts.notStarted > 0;
    const hasAnyCompletedOrRejected = counts.approved + counts.rejected > 0;
    return hasAnyCompletedOrRejected && !hasIncompleteItems;
};

const hasProgressItems = (counts) => {
    const hasAnyProgressItems = counts.submitted + counts.approved + counts.rejected > 0;
    return hasAnyProgressItems;
};

const isAllInProgress = (counts, total) => {
    return counts.submitted === total;
};
